/**
 * Customer Portal API
 * See `api-description.md` for detailed description.
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface MeteringPointName { 
    /**
     * Metering point metadata ID
     */
    meteringPointMetadataId: string;
    /**
     * Metering point name
     */
    name?: string;
}

